<template>
  <div>
    <h3>{{$tc('aspect', 2)}}</h3>
    <v-flex d-flex lg12 md12 sm12 xs12>
      <v-flex d-flex lg4 md4 sm6 xs12>
        <v-select
          :disabled="!Edit"
          :rules="[v => rules.vacio(v,'order')]"
          :items="rangeSelect"
          :label="$t('order')"
          v-model="order"
        ></v-select>
      </v-flex>
      <v-flex d-flex lg4 md4 sm6 xs12>
        <v-autocomplete
          :disabled="!Edit"
          :items="list"
          :rules="[v => rules.vacio(v,'aspect')]"
          :label="$tc('aspect')"
          v-model="aspect"
        ></v-autocomplete>
      </v-flex>
      <v-flex d-flex lg4 md4 sm6 xs12>
        <v-autocomplete
          :disabled="!Edit"
          :items="categoria"
          :rules="[v => rules.vacio(v,'category')]"
          :label="$tc('category')"
          v-model="category"
        ></v-autocomplete>
      </v-flex>
      <v-flex d-flex lg4 md4 sm6 xs12>
        <v-autocomplete
          :disabled="!Edit"
          :items="tipo"
          :rules="[v => rules.vacio(v,'type')]"
          :label="$t('type')"
          v-model="type"
        ></v-autocomplete>
      </v-flex>
    </v-flex>
    <v-container>
      <v-flex d-flex lg12 md12 sm12 xs12>
        <div class="v-table__overflow">
          <table
            class="v-datatable v-table theme--light"
            style="width: 100%; text-align: center"
            v-if="localAspect.length > 0"
          >
            <thead>
              <tr>
                <th>{{$t('order')}}</th>
                <th>{{$tc('aspect')}}</th>
                <th>{{$tc('category')}}</th>
                <th>{{$t('type')}}</th>
                <th>{{$t('actions')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(aspectOne, index) in localAspect" :key="index+200">
                <td>
                  <template
                    v-if="index !== selected"
                  >{{searchAspect(aspectOne.aspectId)}}</template>
                  <template v-else>
                    <v-select
                      :disabled="!Edit"
                      :rules="[v => rules.vacio(v,'order')]"
                      :items="rangeSelect"
                      :label="$t('order')"
                      v-model="aspectOne.order"
                    ></v-select>
                  </template>
                </td>
                <td class="px-2">
                  <template v-if="index !== selected">{{searchAspect(aspectOne.aspectId)}}</template>
                  <template v-else>
                    <v-autocomplete
                      :disabled="!Edit"
                      :items="list"
                      :rules="[v => rules.vacio(v,'aspect')]"
                      :label="$tc('aspect')"
                      v-model="aspectOne.aspectId"
                    ></v-autocomplete>
                  </template>
                </td>
                <td class="px-2">
                  <template v-if="index !== selected">{{searchCategory(aspectOne.categoryAspect)}}</template>
                  <template v-else>
                    <v-autocomplete
                      :disabled="!Edit"
                      :items="categoria"
                      :rules="[v => rules.vacio(v,'category')]"
                      :label="$tc('category')"
                      v-model="aspectOne.categoryAspect"
                    ></v-autocomplete>
                  </template>
                </td>
                <td class="px-2">
                  <template v-if="index !== selected">{{searchType(aspectOne.typeAspect)}}</template>
                  <template v-else>
                    <v-autocomplete
                      :disabled="!Edit"
                      :items="tipo"
                      :rules="[v => rules.vacio(v,'type')]"
                      :label="$t('type')"
                      v-model="aspectOne.typeAspect"
                    ></v-autocomplete>
                  </template>
                </td>
                <td class="px-2 text-xs-center">
                  <v-btn v-if="index !== selected" flat icon color="success" class="px-0 mx-0">
                    <v-icon class="icon material-icons" @click="selected = index">create</v-icon>
                  </v-btn>
                  <v-btn v-else flat icon color="secondary" class="px-0 mx-0">
                    <v-icon class="icon material-icons" @click="saveAspect">save</v-icon>
                  </v-btn>
                  <v-btn flat icon color="error" class="px-0 mx-0">
                    <v-icon class="icon material-icons" @click="removeAspect(index)">delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-flex>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="addAspect()" color="success" small>{{$t('add')}}</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { rangexy } from '../../../helpers'
import queueToast from '../../../helpers/queueToast'
import rules from '../../../helpers/rules'

export default {
  name: 'tabAspects',
  mixins: [rules],
  props: {
    editExternal: {
      type: Boolean,
      required: false,
      default: true
    },
    Edit: {
      type: Boolean,
      default: true
    },
    action: {
      type: String,
      required: true
    }
  },
  watch: {
    currentAct: function(val) {
      if (val) {
        if (this.action === 'update' || this.action === 'delete') {
          if (val && val.aspects) {
            this.localAspect = val.aspects
            this.sortLocalAspect()
          }
        }
      }
    },
    localAspect(val) {
      this.updateOrder()
    },
    action: function(val) {
      if (val === 'update' || val === 'delete') {
        if (this.currentAct && this.currentAct.aspects) {
          this.localAspect = this.currentAct.aspects
        }
      }
      if (val === 'view') {
        this.localAspect = []
      }
    }
  },
  mounted() {
    this.rangeValue = rangexy(0, 99)
    let me = this
    this.rangeValue.forEach(item => {
      me.rangeSelect.push({
        text: item + '',
        value: item 
      })
    })
    if (this.action === 'update' || this.action === 'delete') {
      if (this.currentAct && this.currentAct.aspects) {
        this.localAspect = this.currentAct.aspects
      }
    }
    this.updateOrder()
    this.sortLocalAspect()
  },
  data() {
    return {
      tmp: '',
      dialog: true,
      aspect: '',
      order: 0,
      category: '',
      type: '',
      localAspect: [],
      rangeValue: 0,
      rangeSelect: [],
      selected: ''
    }
  },
  computed: {
    ...mapState({
      list: state => state.aspects.listSelect,
      currentAct: state => state.acts.actSelected,
      languages: state => state.languages.listLanguages
    }),

    tipo() {
      if (!this.currentAct || !this.currentAct.typeAspects) {
        return []
      }
      let result = []
      this.currentAct.typeAspects.forEach(item => {
        let name = ''
        let id = ''
        item.name.forEach(element => {
          if (
            element.langId === '5bd9ebae37c431001498335d' ||
            element.langId === '5bd9f3ee7fa5610014fed21e'
          ) {
            name = element.text
            id = item._id
          }
        })
        result.push({
          text: name,
          value: id,
          order: parseInt(item.order)
        })
      })
      result.sort(function(a, b) {
        if (a.order > b.order) {
          return 1
        }
        if (a.order < b.order) {
          return -1
        }
        return 0
      })
      return result
    },
    categoria() {
      if (!this.currentAct || !this.currentAct.categoryAspects) {
        return []
      }
      let result = []
      this.currentAct.categoryAspects.forEach(item => {
        let name = ''
        let id = ''
        item.name.forEach(element => {
          if (
            element.langId === '5bd9ebae37c431001498335d' ||
            element.langId === '5bd9f3ee7fa5610014fed21e'
          ) {
            name = element.text
            id = item._id
          }
        })
        result.push({
          text: name,
          value: id,
          order: item.order
        })
      })
      result.sort(function(a, b) {
        if (a.order > b.order) {
          return 1
        }
        if (a.order < b.order) {
          return -1
        }
        return 0
      })
      return result
    }
  },
  methods: {
    sortLocalAspect() {
      if (this.localAspect.length === 0) {
        return []
      }
      let me = this
      this.localAspect.sort(function(a, b) {
        let aCategory = me.categoria.find(
          item => item.value === a.categoryAspect
        )
        let bCategory = me.categoria.find(
          item => item.value === b.categoryAspect
        )
        if (aCategory && bCategory) {
          if (aCategory.order > bCategory.order) {
            return 1
          }
          if (aCategory.order < bCategory.order) {
            return -1
          }
        }
        let aType = me.tipo.find(item => item.value === a.typeAspect)
        let bType = me.tipo.find(item => item.value === b.typeAspect)
        if (aType && bType) {
          if (aType.order > bType.order) {
            return 1
          }
          if (aType.order < bType.order) {
            return -1
          }
        }
        return a.order - b.order
      })
      this.localAspect = this.localAspect.map((aspect, index) => ({
        ...aspect,
        order: index + 1
      }))
      return this.localAspect
    },
    searchType(id) {
      let result = this.tipo.find(item => item.value === id)
      if (!result) {
        return ''
      }
      return result.text
    },

    searchCategory(id) {
      let result = this.categoria.find(item => item.value === id)
      return result ? result.text : ''
    },

    searchAspect(id) {
      let result = this.list.find(item => item.value === id)
      return result ? result.text : ''
    },

    addAspect() {
      const error = this.verifyAspect()
      if (!error.error) {
        queueToast(error.message)
        return
      }

      let index = this.localAspect.findIndex(
        aspect => aspect.order == this.order
      )
      if (index != -1) {
        this.localAspect.forEach((aspect, aIndex) => {
          if (aIndex >= index) {
            aspect.order++
          }
        })
      }
      this.localAspect.push({
        aspectId: this.aspect,
        categoryAspect: this.category,
        typeAspect: this.type,
        order: this.order
      })
      this.$emit('update', this.localAspect)
      this.sortLocalAspect()
      let me = this
      setTimeout(function() {
        me.aspect = ''
        me.category = ''
        me.type = ''
      }, 500)
    },

    updateOrder() {
      let orders = this.localAspect.map(item => item.order)
      let maxOrder = orders.length ? Math.max(...orders) : 0
      this.order = maxOrder + 1 
    },
    removeAspect(index) {
      this.localAspect.splice(index, 1)
      this.$emit('update', this.localAspect)
      this.sortLocalAspect()
    },
    saveAspect() {
      this.selected = ''
      this.sortLocalAspect()
    },

    verifyAspect() {
      let error = true
      let message = []
      if (!this.aspect) {
        error = false
        message.push(this.$t('error.required', { field: this.$tc('aspect') }))
      }
      if (!this.category) {
        error = false
        message.push(this.$t('error.required', { field: this.$tc('category') }))
      }
      if (!this.type) {
        error = false
        message.push(this.$t('error.required', { field: this.$t('type') }))
      }
      if (this.order < 1) {
        error = false
        message.push(this.$t('error.required', { field: this.$t('order') }))
      }
      return {
        error,
        message
      }
    }
  }
}
</script>
